import _entriesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/entries";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import Err from "@Client/@Routes/error";
import { getDocumentSignedURL, markRequestAsCompleted, validateToken, markDocumentAsUploaded } from "../api/noa-portal-api";
import { SET_AUTH_DATA, SET_CLIENT_APPLICATION_REQUEST, UPDATE_UPLOAD_STATUS } from "./noa-portal-mutations";
import { putS3Data } from "@Shared/utils/ajax";
export const VERIFY_TOKEN = "VERIFY_TOKEN";
export const SUBMIT_COMPLETED_REQUEST = "SUBMIT_COMPLETED_REQUEST";
export const SUBMIT_ISSUE_REQUEST = "SUBMIT_ISSUE_REQUEST";
const actions = {
  [VERIFY_TOKEN]: async (context, {
    token,
    code
  }) => {
    try {
      const {
        clientApplicationRequest
      } = await validateToken(token, code);
      context.commit(SET_AUTH_DATA, {
        token,
        code
      });
      context.commit(SET_CLIENT_APPLICATION_REQUEST, {
        clientApplicationRequest
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [SUBMIT_COMPLETED_REQUEST]: async (context, {
    status,
    files,
    description
  }) => {
    try {
      const {
        token,
        code
      } = context.state;
      const totalDocuments = files.length;
      const documentIds = [];
      for (const [current, file] of _entriesInstanceProperty(files).call(files)) {
        var _context;
        context.commit(UPDATE_UPLOAD_STATUS, {
          total: totalDocuments,
          current
        });
        const fileName = _replaceAllInstanceProperty(_context = file.name).call(_context, " ", "-");
        const signed = await getDocumentSignedURL(token, code, {
          fileName
        });
        documentIds.push(signed.documentId);
        await putS3Data(file, signed.url, signed.contentType);
      }
      await markDocumentAsUploaded(token, code, {
        documentIds,
        issue: description
      });
      await markRequestAsCompleted(token, code, {
        status,
        issue: description
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [SUBMIT_ISSUE_REQUEST]: async (context, {
    status,
    issue
  }) => {
    try {
      const {
        token,
        code
      } = context.state;
      await markRequestAsCompleted(token, code, {
        status,
        issue
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  }
};
export default actions;